import { state } from '@angular/animations';
import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { IProducts } from '../models/products.model';

export const currentProductsFeatureKey = 'currentProducts';

export interface CurrentProductsState {
  loadCurrentProductsResponse: IProducts[];
  loadCurrentProductsFailure: Error | any;
  loadUpcomingProducts: IProducts[];
}

export const initialState: CurrentProductsState = {
  loadUpcomingProducts: undefined,
  loadCurrentProductsResponse: undefined,
  loadCurrentProductsFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(actions.loadCurrentProducts, (state, action) => ({
    ...state
  })),
  on(actions.loadCurrentProductsSuccess, (state, action) => ({
    ...state,
    loadCurrentProductsResponse: action.response
  })),
  on(actions.loadCurrentProductsFailure, (state, action) => ({
    ...state,
    loadCurrentProductsFailure: action.error
  })),
  on(actions.loadUpcomingProductsSuccess, (state, action) => ({
    ...state,
    loadUpcomingProducts: action.response
  }))
);

export const getCurrentProductsResponse = (state: CurrentProductsState) => state.loadCurrentProductsResponse;

export const getUpcomingProductsResponse = (state: CurrentProductsState) => state.loadUpcomingProducts;
